<footer class="layout-footer">
  <small class="text-center">
    <ng-container i18n="@@FooterCopyright"> Copyright 1998 - {{ copyrightYear() }} LUMATRAK, Inc. End-to-End Supply Chain Visibility </ng-container>
    <br />
    <ng-container i18n="@@FooterConfidential"> All information is confidential and proprietary to PULSE. </ng-container>
  </small>
</footer>
